import _taggedTemplateLiteral from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import { css as _css } from "styled-components";
import { keyframes as _keyframes } from "styled-components";
import _styled from "styled-components";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["animation: ", " 2s ease-out infinite 0.5s;"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  50% {\n    opacity: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from "react";
import { ReactComponent as PowerIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/power.svg";

var blinkAnimation = _keyframes(_templateObject());

var Circle = _styled.button.withConfig({
  displayName: "PowerButton__Circle",
  componentId: "sc-1sbmvif-0"
})(["cursor:pointer;display:flex;align-items:center;justify-content:center;position:relative;height:40px;width:40px;border:0;border-radius:50%;background:white;transition:all 0.2s;& svg{display:block;transition:all 0.2s;opacity:1;color:var(--state-color-", ");color:", ";", "}"], function (p) {
  return p.isActive ? p.activeColor : "gray";
}, function (p) {
  return p.isActive ? "var(--state-active-color)" : "var(--state-color-gray)";
}, function (p) {
  return p.syncing ? _css(_templateObject2(), blinkAnimation) : 'opacity: 1;';
});

export function PowerButton(_ref) {
  var isActive = _ref.isActive,
      _ref$activeColor = _ref.activeColor,
      activeColor = _ref$activeColor === void 0 ? "blue" : _ref$activeColor,
      onChange = _ref.onChange,
      _ref$syncing = _ref.syncing,
      syncing = _ref$syncing === void 0 ? false : _ref$syncing;
  return /*#__PURE__*/React.createElement(Circle, {
    isActive: isActive,
    syncing: syncing,
    onClick: onChange
  }, /*#__PURE__*/React.createElement(PowerIcon, null));
}